import { isAppsInTossHost } from "./apps-in-toss";
export async function copyText(text: string) {
 if (isAppsInTossHost()) { const { setClipboardText } = await import("@apps-in-toss/web-framework"); await setClipboardText(text); }
 else await navigator.clipboard.writeText(text);
}
